import React from 'react';

import { getTranslation } from 'common/react/utils/translations';
import { PlayerProfileLink } from 'widgets/statspro/js/components/common/PlayerProfileLink';
import PropTypes from 'prop-types';

const HEADSHOT_SIZE = 96;

export const InsAndOutsPlayer = ({ player, reason }) => {
    return (
        <PlayerProfileLink
            classes="team-lineups-ins-and-outs__grid-item"
            player={{
                playerId: player.playerId,
                firstName: player.playerName.givenName,
                surname: player.playerName.surname
            }}
        >
            <div>
                <p className="team-lineups-ins-and-outs__player-name">
                    {player.playerName.givenName} {player.playerName.surname}
                </p>
                {reason ? (
                    <p className="team-lineups-ins-and-outs__player-reason">
                        {reason}
                    </p>
                ) : null}
            </div>
            <div className="team-lineups-ins-and-outs__headshot">
                <img
                    loading="lazy"
                    className="team-lineups-ins-and-outs__headshot-image"
                    alt={`${getTranslation('label.stats.headshot.alt')} ${
                        player.playerName.givenName
                    } ${player.playerName.surname}`}
                    src={PULSE.app.common.image.migratePlayerPhotoURL(
                        player.photoURL,
                        false,
                        HEADSHOT_SIZE,
                        true
                    )}
                />
            </div>
        </PlayerProfileLink>
    );
};

InsAndOutsPlayer.propTypes = {
    player: PropTypes.object.isRequired,
    reason: PropTypes.string
};
